import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useFirebaseRemoteConfig } from "./use-firebase-remote-config";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useABTestingSWR() {
  const { loadABTestingMatrix } = useFirebaseRemoteConfig();

  return useSWR(getSWRKey(SwrStore.AbTestingMatrix), loadABTestingMatrix, {
    revalidateIfStale: false,
  });
}
